import type { UserInfoResponse } from '~/clients/derived-api-types'

type Issuer = UserInfoResponse['issuer'] | null | undefined
type Options = { includeMock?: boolean }

export function isDeepinsightUser(issuer: Issuer, { includeMock = true }: Options = {}): boolean {
    // google matches today's logic, but this could easily break if a future hospital uses this stack
    return issuer === 'google' || (includeMock && issuer === 'mock')
}
